import { Action } from '@reduxjs/toolkit';

import { ThunkDispatchType } from 'app/redux/types';

import { API, getAsyncThunk } from 'app/api';

// ---

export const getResultMatches = getAsyncThunk(
  'MATCH_RESULT:GET_MATCHES',
  API.matches.getMatchResult,
);

export const fetchMatches = (
  sportId: number,
  sportName: string,
  startDate: Date,
  endDate: Date,
) => (dispatch: ThunkDispatchType) => {
  const updatedStartDate = new Date(startDate);
  updatedStartDate.setHours(0, 0, 0);

  const updatedEndDate = new Date(endDate);
  updatedEndDate.setHours(23, 59, 59);

  const startDateISOString = updatedStartDate.toISOString();
  const endDateISOString = updatedEndDate.toISOString();
  const payload = {
    sportId,
    sportName,
    startDate: startDateISOString,
    endDate: endDateISOString,
  };

  return dispatch(getResultMatches(payload));
};

// ---

export const REMOVE_MATCHES_BY_SPORT_ID = 'RESULTS_PAGE:REMOVE_MATCHES';

export type RemoveMatchesBySportIdActionType = Action<
  typeof REMOVE_MATCHES_BY_SPORT_ID
> & { sportId: number };

export const removeMatchesBySportId = (sportId: number): RemoveMatchesBySportIdActionType => ({
  type: REMOVE_MATCHES_BY_SPORT_ID,
  sportId,
});

// ---

export const fetchSports = getAsyncThunk(
  'MATCH_RESULT:GET_SPORTS',
  API.matches.getMatchResultSports,
);

// ---

export const RESET_RESULTS_VALUES = 'RESULTS_PAGE:RESET_RESULTS_VALUES';

export type ResetValuesActionType = Action<
  typeof RESET_RESULTS_VALUES
>;

export const resetValues = (): ResetValuesActionType => ({
  type: RESET_RESULTS_VALUES,
});
